const hideResponseMessage = function (selector, hideAfter) {
  setTimeout(() => {
    $(selector).slideUp(800);
  }, hideAfter || 5000);
};
$(() => {
  hideResponseMessage('.validationErrors');
  let ctrialVersion,
    ctrialVersion_2,
    cpayVersion,
    back_1,
    back_2,
    heading1,
    heading2,
    heading3,
    nextReg,
    backReg;
  ctrialVersion = $('#content-registerform');
  ctrialVersion_2 = $('#content-registerform-2');
  cpayVersion = $('#content-paymentform');
  back_1 = $('#back-1');
  back_2 = $('#back-2');
  heading1 = $('#heading1');
  heading2 = $('#heading2');
  heading3 = $('#heading3');
  $(back_1).hide();
  $(back_2).hide();
  $(heading2).hide();
  $(heading3).hide();
  $(ctrialVersion_2).hide();
  $(cpayVersion).hide();

  /* display next Pages */
  nextReg = function (backPrev, backNext, headingPrev, headingNext, prevPage, nextPage, step) {
    trackSteps(step);

    if (typeof backPrev === 'undefined') {
      return;
    }
    $(backPrev).stop(true, true).fadeOut(300);
    $(backNext).stop(true, true).delay(800).fadeIn(300);
    $(headingPrev).stop(true, true).fadeOut(400);
    $(headingNext).stop(true, true).delay(400).fadeIn(400);
    $(nextPage).stop(true, true).fadeIn().animate({ left: '0' });
    $(prevPage).stop(true, true).animate({ left: '-900' }).delay(500).fadeOut();
  };

  $('#show-registerform-2').on('click', () => {
    nextReg('', $(back_1), $(heading1), $(heading2), $(ctrialVersion), $(ctrialVersion_2), 1);
  });

  $('#show-paymentform').on('click', () => {
    nextReg($(back_1), $(back_2), $(heading2), $(heading3), $(ctrialVersion_2), $(cpayVersion), 2);
  });

  /* display previous pages */

  backReg = function (backPrev, backNext, headingPrev, headingNext, prevPage, nextPage, step) {
    trackSteps(step);

    $(backPrev).fadeOut(300);
    if (backNext === undefined) {
      return;
    }
    $(backNext).stop(true, true).delay(800).fadeIn(300);
    $(headingPrev).stop(true, true).fadeOut(400);
    $(headingNext).stop(true, true).delay(400).fadeIn(400);
    $(nextPage).stop(true, true).fadeIn().animate({ left: '0' });
    $(prevPage).stop(true, true).animate({ left: '900' }).delay(500).fadeOut();
  };

  $('#back-1').on('click', () => {
    backReg($(back_1), '', $(heading2), $(heading1), $(ctrialVersion_2), $(ctrialVersion), 0);
  });

  $('#back-2').on('click', () => {
    backReg($(back_2), $(back_1), $(heading3), $(heading2), $(cpayVersion), $(ctrialVersion_2), 1);
  });
});
